module.exports = __webpack_public_path__ + "media/images/portugal_center/coimbra2-64b03a63ea2f13323d540c27c2920669.jpg";